<template>
    <div class="users-style">
        
        
        <a v-if="company_name" class="nav-link dropdown-toggle text-white rounded py-0 mt-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  href="">
            <span class="comapny-left-block d-inline-block align-middle">
                <span class="menu-company-img"><b-avatar variant="info" v-bind:src="$api_url+'/images/company/'+company_logo" class="mr-0 rounded-0 agent-logo" size="36px"></b-avatar></span>
                <span class="menu-company-name text-uppercase">{{company_name}}</span>
            </span>
        </a>        
        
        <a v-else class="nav-link dropdown-toggle text-white rounded no-data mt-0 py-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  href="">
            <span class="menu-company-img"><img v-bind:src="$api_url+'/images/no-company.jpg'" class="mr-0 rounded-0 agent-logo" width="36px"></span>
            <span class="company-not-selected">Select Company</span><span class="arrow"></span>
        </a>
        
        
        <ul class="dropdown-menu dropdown-menu-left ">
            <li class="nav-item" v-for='company in companies'>
                <a v-if="company.id == company_id" class="nav-link active" :href="'#'" @click="selectCompany(company.id)"><b-avatar variant="info" v-bind:src="$api_url+'/images/company/'+company.logo" class="mr-0 rounded-0 agent-logo" size="30px"></b-avatar>{{company.name}}</a>
                <a v-else class="nav-link " :href="'#'" @click="selectCompany(company.id)"><b-avatar variant="info" v-bind:src="$api_url+'/images/company/'+company.logo" class="mr-0 rounded-0 agent-logo" size="30px"></b-avatar>{{company.name}}</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :href="$api_url+'/company/'">All Companies</a>
            </li>
        </ul>
    </div>
</template>
<script>
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
        },
        data(){            
            
            return {               
                
                companies: [],
                company_logo: null,                
                company_name:null,
                company_id:null,
                
            }
        },
        methods:{
            getAgentCompany: function()
            {
                axios.get(this.$api_url+'/company/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.companies = response.data.companies;
                    this.getCurrentCompany();
                }.bind(this));
            },
            getCurrentCompany: function()
            {
                axios.get(this.$api_url+'/company/publicinfo' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){         
                    //console.log(response.data);           
                    this.company_logo = response.data.logo;
                    this.company_name = response.data.name;
                    this.company_id = response.data.id;
                }.bind(this));
            },
            selectCompany:function(x)
            {               
                let formData = new FormData();
                formData.append('company_id', x);
                axios.post(this.$api_url+'/company/setcompany', formData)
                                .then(function (response) 
                                {                                                                    
                                    window.location.href = this.$api_url+'/company/dashboard';
                                    //window.location.reload(true);
                                    
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            

        },
        created: function(){
            this.getAgentCompany();
        }
    }
</script>